module.exports = __webpack_public_path__ + "img/logo-grocer.40e871a0.png";